import { forwardRef, createElement } from 'react';

function IconInbox(props, svgRef) {
  return createElement("svg", Object.assign({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.258 4c.744 0 1.407.47 1.652 1.172l2.992 8.547c.065.186.098.382.098.578v3.953a1.75 1.75 0 01-1.607 1.744L20.25 20H3.75A1.75 1.75 0 012 18.25v-3.953c0-.197.033-.392.098-.578L5.09 5.172A1.75 1.75 0 016.742 4h10.516zm-.177 2H6.918l-2.8 8h3.229a1 1 0 01.916.598l.974 2.22a1 1 0 00.916.599h3.694a1 1 0 00.915-.598l.976-2.221a1 1 0 01.915-.598h3.228l-2.8-8z",
    fill: "currentColor"
  }));
}

var Inbox = /*#__PURE__*/forwardRef(IconInbox);

export default Inbox;
//# sourceMappingURL=Inbox.js.map
